import { SAVE_TOP_FILTER_VALUES, GET_TOP_FILTER_VALUES, REMOVE_TOP_FILTER_VALUES } from '../../util/actionTypes';
import {getCredentialsFromCookie} from '../../util/helper';
const initialState ={
    selectedBroker: "",
    brokerID: "",
    optionsTradingType: "",
    instrument: "",
    selectExpiry: "",
    broker:{}
};

const filterReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case SAVE_TOP_FILTER_VALUES: 
            return {
                ...state,
                ...action.payload, 
              };     
  
        default:
            return state;
    }
};

export default filterReducer;
